<template>
  <BaseHeader
    :title="baseHeaderTitle"
    :style-variant="1"
    wrapperClass="header mt-md-4"
  >
    <template
      v-if="!isPlatformBottimmo"
      v-slot:design
    >
      <HeaderDesign />
    </template>

    <template v-slot:desc>
      <p>
        {{ $t('dashboard.baseHeader.text') }}
      </p>
    </template>
  </BaseHeader>
</template>

<script setup lang="ts">
import { computed, inject } from 'vue'
import { useI18n } from 'vue-i18n'

import { AuthInstance } from '@/auth'
import BaseHeader from '@/components/BaseHeader.vue'
import { useBranding } from '@/composables/useBranding'
const { t } = useI18n()
const auth = inject<AuthInstance>('auth')
const { isPlatformBottimmo } = useBranding()
const baseHeaderTitle = computed(() => {
  return auth?.user?.given_name
    ? `${t('dashboard.baseHeader.title')}, ${auth.user.given_name}!`
    : t('dashboard.baseHeader.title')
})
</script>
